import { gql } from 'graphql-tag';

export const GET_BRANCH_CATEGORIES = gql`
  query GetBranchCategories(
    $pagination: PaginationInput
    $filter: LocationCategoryFilterInput
    $sort: LocationCategorySortInput
  ) {
    branchCategories(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        name
        color
        accountId
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_BRANCH_CATEGORY = gql`
  query GetBranchCategory($id: ID!) {
    branchCategory(id: $id) {
      id
      name
      color
      accountId
      createdAt
      updatedAt
    }
  }
`;
